import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';
import { RouteRoutingModule } from './routes-routing.module';
// dashboard pages
import { DashboardComponent } from './dashboard/dashboard.component';
// passport pages
import { UserLoginComponent } from './passport/login/login.component';
import { UserRegisterComponent } from './passport/register/register.component';
import { UserRegisterResultComponent } from './passport/register-result/register-result.component';
// single pages
import { CallbackComponent } from './callback/callback.component';
import { UserLockComponent } from './passport/lock/lock.component';
import { Exception403Component } from './exception/403.component';
import { Exception404Component } from './exception/404.component';
import { Exception500Component } from './exception/500.component';
import { LicenseGrantComponent } from './license-grant/license-grant.component';
import { LicenseComponent } from './passport/license/license.component';
import { ProcessViewComponent } from './workflow/process-view/process-view.component';
import { ResetPasswordComponent } from './passport/reset-password/reset-password.component';
import { SendEmailSuccessComponent } from './passport/send-email-success/send-email-success.component';
import { ResetPasswordPageComponent } from './passport/reset-password-page/reset-password-page.component';


const COMPONENTS = [
  DashboardComponent,
  // passport pages
  UserLoginComponent,
  UserRegisterComponent,
  UserRegisterResultComponent,
  // single pages
  CallbackComponent,
  UserLockComponent,
  Exception403Component,
  Exception404Component,
  Exception500Component,
  LicenseGrantComponent,
  LicenseComponent,
  ProcessViewComponent,
  ResetPasswordComponent,
  SendEmailSuccessComponent,
  ResetPasswordPageComponent,
];
const COMPONENTS_NOROUNT = [];

@NgModule({
  imports: [SharedModule, RouteRoutingModule],
  declarations: [
    ...COMPONENTS,
    ...COMPONENTS_NOROUNT,
  ],
  entryComponents: COMPONENTS_NOROUNT
})
export class RoutesModule {
}
